import { useTheme } from "styled-components";
import { FaCheckCircle, FaExclamationTriangle, FaTimes } from "react-icons/fa";
import { CarrierOutageBannerColor } from "models/carrierOutageBanner/carrierOutageBanner.model";

type TopBannerProps =
  | {
      variant?: "onstop" | "inactive";
      text?: never;
      color?: never;
      onClose?: never;
    }
  | {
      variant: "carrierOutage";
      text: string;
      // Orange while the carrier is down, green once it is back up.
      color?: CarrierOutageBannerColor;
      // Shows an X that hides the banner.
      onClose?: () => void;
    };

export default function TopBanner({
  variant = "onstop",
  text,
  color = "orange",
  onClose,
}: TopBannerProps) {
  const theme = useTheme();
  const isInactive = variant === "inactive";

  // Staff-written carrier outage notice for the listed accounts (Settings →
  // Carrier outage banners on SUPPLIES DO NOT BILL).
  if (variant === "carrierOutage") {
    return (
      <div
        role="status"
        style={{ background: theme.colors[color][9] }}
        className={`relative flex items-center justify-center gap-x-3 py-2.5 ${
          onClose ? "px-14" : "px-6"
        }`}
        data-testid="carrier-outage-banner"
        data-color={color}
      >
        {color === "green" ? (
          <FaCheckCircle className="flex-none text-white" />
        ) : (
          <FaExclamationTriangle className="flex-none text-white" />
        )}
        <p className="leading-6 text-white text-center whitespace-pre-line">
          <strong className="font-semibold">{text}</strong>
        </p>
        {onClose && (
          // A plain X like the mobile menu's close, in the banner's white
          // text, so it doesn't compete with the message.
          <button
            type="button"
            onClick={onClose}
            aria-label="Hide this banner"
            data-testid="carrier-outage-banner-close"
            className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center rounded-md text-white opacity-70 hover:opacity-100"
          >
            <FaTimes size={14} />
          </button>
        )}
      </div>
    );
  }

  return (
    <div
      style={{ background: isInactive ? theme.colors.gray[9] : "red" }}
      className="flex items-center justify-center gap-x-6 px-6 py-2.5"
    >
      <p className="leading-6 text-white">
        <strong className="font-semibold">
          {isInactive
            ? "ACCOUNT INACTIVE. Please contact ITD UK."
            : "ON STOP. Please contact ITD UK."}
        </strong>
      </p>
    </div>
  );
}
